import { css } from 'styled-components';

export const fonts = css`
	@font-face {
		font-family: 'Sharp Slab';
		font-style: normal;
		font-weight: 700;
		src: local('Sharp Slab Bold'), url('/dist/fonts/SharpSlab-Bold.woff2') format('woff2'),
			url('/dist/fonts/SharpSlab-Bold.woff') format('woff');
	}
	@font-face {
		font-family: 'Sharp Slab';
		font-style: normal;
		font-weight: 600;
		src: local('Sharp Slab SemiBold'), url('/dist/fonts/SharpSlab-SemiBold.woff2') format('woff2'),
			url('/dist/fonts/SharpSlab-SemiBold.woff') format('woff');
	}
	@font-face {
		font-family: 'Sharp Slab';
		font-style: normal;
		font-weight: 300 400;
		src: local('Sharp Slab Light'), url('/dist/fonts/SharpSlab-Light.woff2') format('woff2'),
			url('/dist/fonts/SharpSlab-Light.woff') format('woff');
	}

  /* Arimo Regular (400) */
  @font-face {
    font-family: 'Arimo';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: local('Arimo Regular'), local('Arimo-Regular'),
        url('/dist/fonts/Arimo-Regular.woff2') format('woff2'),
        url('/dist/fonts/Arimo-Regular.woff') format('woff');
  }

  /* Arimo Medium (500) */
  @font-face {
    font-family: 'Arimo';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: local('Arimo Medium'), local('Arimo-Medium'),
        url('/dist/fonts/Arimo-Medium.woff2') format('woff2'),
        url('/dist/fonts/Arimo-Medium.woff') format('woff');
  }

  /* Arimo Bold (700) */
  @font-face {
    font-family: 'Arimo';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: local('Arimo Bold'), local('Arimo-Bold'),
        url('/dist/fonts/Arimo-Bold.woff2') format('woff2'),
        url('/dist/fonts/Arimo-Bold.woff') format('woff');
  }

  /* legacy */
  /* Arimo Medium (500) */
  @font-face {
    font-family: 'Arimo Medium';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: local('Arimo Medium'), local('Arimo-Medium'),
        url('/dist/fonts/Arimo-Medium.woff2') format('woff2'),
        url('/dist/fonts/Arimo-Medium.woff') format('woff');
  }

  /* Arimo Bold (700) */
  @font-face {
    font-family: 'Arimo Bold';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: local('Arimo Bold'), local('Arimo-Bold'),
        url('/dist/fonts/Arimo-Bold.woff2') format('woff2'),
        url('/dist/fonts/Arimo-Bold.woff') format('woff');
  }

  /* Arimo Italic (400 italic) */
  @font-face {
    font-family: 'Arimo';
    font-style: italic;
    font-weight: 400;
    font-display: swap;
    src: local('Arimo Italic'), local('Arimo-Italic'),
        url('/dist/fonts/Arimo-Italic.woff2') format('woff2'),
        url('/dist/fonts/Arimo-Italic.woff') format('woff');
  }

  /* Arimo Medium Italic (500 italic) */
  @font-face {
    font-family: 'Arimo';
    font-style: italic;
    font-weight: 500;
    font-display: swap;
    src: local('Arimo Medium Italic'), local('Arimo-MediumItalic'),
        url('/dist/fonts/Arimo-MediumItalic.woff2') format('woff2'),
        url('/dist/fonts/Arimo-MediumItalic.woff') format('woff');
  }

  /* Arimo Bold Italic (700 italic) */
  @font-face {
    font-family: 'Arimo';
    font-style: italic;
    font-weight: 700;
    font-display: swap;
    src: local('Arimo Bold Italic'), local('Arimo-BoldItalic'),
        url('/dist/fonts/Arimo-BoldItalic.woff2') format('woff2'),
        url('/dist/fonts/Arimo-BoldItalic.woff') format('woff');
  }
`;

export default fonts;
